import React from 'react';
import {
     Layout, Button,
} from 'antd';
import MiCompAPI from '../../util/api';
    
import CarrierBook from './CarrierBook';
import EntityBookOfBusiness from '../EntityBookOfBusiness';

const { Content } = Layout;
class Book extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            carriers: null,
            currentTab: "book",
            isLoading: false,
            client_id: null,
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            user_id: 0,
            book: null,
            expandData: false,
            summaryDetail: false,
            actualAmount: [
                {
                    clienttype: "broker", clientname: "broker1", commissionamount: 5496,
                    
                },
                {
                    clienttype: "agency", clientname: "agency1", commissionamount: 789,
                     
                },
                {
                    clienttype: "carrier", clientname: "carrier1", commissionamount: 2334, 
                  
                },
            ]
        };
        this.api = new MiCompAPI(this.props.userPermandMasters);
        this.columns = [
            {
                title: 'Client Type',
                dataIndex: 'clienttype',
                sorter: (a, b) => a.clienttype.localeCompare(b.clienttype),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: ' Client Name',
                dataIndex: 'clientname',
                sorter: (a, b) => a.clientname.localeCompare(b.clientname),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Commission Amount',
                dataIndex: 'commissionamount',
                sorter: (a, b) => a.commissionamount - b.commissionamount,
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Summary',
                dataIndex: 'summary',
                width: 40,
        render: () => {
          return (
            <div >
            <Button onClick={this.SummaryCloseHandler}>
                        summary details
                    </Button>
            </div>
          );
        },
                
            }
        ]
    }




    render() {
         const { decodedToken } = this.props.userPermandMasters;
        var role=decodedToken.UserRoleName;
        return (
            <Content>
                <div style={{margin:'0px 10px'}}>
                 
                   

                        {(role==="carrier"?
                           
                              <CarrierBook  userPermandMasters={this.props.userPermandMasters}  ></CarrierBook> : 
                              <EntityBookOfBusiness userPermandMasters={this.props.userPermandMasters}></EntityBookOfBusiness>)}
                    </div>
               
            </Content>
        );
    }
}
export default Book;